import { MarketInfo, MarketOverall, Pool } from 'interfaces/pool.interface'
import { makeAutoObservable } from 'mobx'

class PoolStore {
  pools: Record<string, Pool>

  constructor() {
    this.pools = {}
    makeAutoObservable(this)
  }

  getPool = (poolAddr: string): Pool => {
    return this.pools[poolAddr] ?? ({} as Pool)
  }

  getMarket = (poolAddr: string, underlyingAddr: string) => {
    return this.pools[poolAddr].marketInfo[underlyingAddr] ?? ({} as MarketInfo)
  }

  getMarketOverall = (
    poolAddr: string,
    underlyingAddr: string,
  ): MarketOverall => {
    return {
      ...this.getPool(poolAddr),
      ...this.getMarket(poolAddr, underlyingAddr),
    }
  }

  setPool = (poolAddr: string, data: Pool) => {
    this.pools[poolAddr] = data
  }
}

export const poolStore = new PoolStore()
